<template>
   <v-container fluid>
    <v-toolbar color="white" flat>
      <v-toolbar-title>Apoiador Planos</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="incluirPlano()">Incluir</v-btn>
    </v-toolbar>
    <v-dialog v-model="dialog" persistent max-width="900">
      <v-card>
        <v-card-title>
          Dados do plano
        </v-card-title>
        <v-card-text>
           <v-row>
                
            <v-col cols="3">
                    <v-text-field
                    v-model="apoiadorPlano.dias"
                    label="Dias do plano"
                    type="number"
                    ></v-text-field>
                </v-col>
            <v-col cols="3">
              <v-text-field
                 v-model="apoiadorPlano.titulo"
                 label="Titulo"
                 ></v-text-field>
              </v-col>
            <v-col cols="3">
              <v-text-field
                 v-model="apoiadorPlano.titulo2"
                 label="Titulo 2"
                 ></v-text-field>
              </v-col>
            <v-col cols="3">
                    <v-text-field
                    v-model="apoiadorPlano.valor"
                    label="Valor"
                    type="number"
                    ></v-text-field>
                </v-col>
            <v-col cols="3">
                    <v-text-field
                    v-model="apoiadorPlano.acessodiario"
                    label="Acesso diário"
                    type="number"
                    ></v-text-field>
                </v-col>
            <v-col cols="3">
                    <v-text-field
                    v-model="apoiadorPlano.bonusdiario"
                    label="Bônus diário"
                    type="number"
                    ></v-text-field>
                </v-col>
            <v-col cols="3">
              <v-text-field
                 v-model="apoiadorPlano.datainicial"
                 v-mask="'##/##/####'"
                 label="Data Inicial"
                 ></v-text-field>
              </v-col>
            <v-col cols="3">
              <v-text-field
                 v-model="apoiadorPlano.datafinal"
                 v-mask="'##/##/####'"
                 label="Data Final"
                 ></v-text-field>
              </v-col>
            <v-col cols="12">
                    
                <v-textarea
                  v-model="apoiadorPlano.informacoes"
                  label="Informações"
                  outlined
                  rows="5"
                >
                </v-textarea>
                </v-col>
            <v-col cols="12">
                    
                <v-textarea
                  v-model="apoiadorPlano.regras"
                  label="Regras"
                  outlined
                  rows="5"
                >
                </v-textarea>
                </v-col>

            </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            ma-2
            text
            small
            color="primary"
            @click="dialog = false"
          >Cancelar</v-btn>
              <v-btn
                ma-2
                text
                small
                color="primary"
                :loading="loading"
                @click="save()"
                >Confirmar</v-btn
              >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
          :key="planosKey"
          :headers="headers"
          :items="planos"
          :items-per-page="10"
          :loading="loading"
          :no-data-text="
            loading ? 'Carregando' : 'Nenhum Registro para mostrar'
          "
          class="elevation-1"
        >
          <template v-slot:[`item.datainicial`]="{ item }">
            <span>{{ formatDate(item.datainicial) }}</span>
          </template>
          <template v-slot:[`item.datafinal`]="{ item }">
            <span>{{ formatDate(item.datafinal) }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <span style="margin-right: 10px;">
              <v-icon small @click="editItem(item)">edit</v-icon></span
            >
            <span>
              <v-icon small @click="deleteItem(item)">delete</v-icon></span
            >
          </template>
        </v-data-table>
    </v-container>
</template>

<script>
export default {
  data(){
    return {
      dialog: false,
      apoiadorPlano: {},
      loading: false,
      planos: [],
      planosKey: 0,
      headers: [
        { text: "", value: "actions", sortable: false },
        {
          text: "Titulo",
          align: "left",
          sortable: true,
          value: "titulo",
        },
        {
          text: "Valor",
          align: "left",
          sortable: true,
          value: "valor",
        },
        {
          text: "Data Início",
          align: "left",
          sortable: true,
          value: "datainicial",
        },
        {
          text: "Data fim",
          align: "left",
          sortable: true,
          value: "datafinal",
        },
      ],
    }
  },
  watch: {
  },
  created() {
    this.fetchPlanos();
  },
  methods: {
    incluirPlano(){
        this.apoiadorPlano = {};
        this.dialog = true;
    },
    salvar(){

    },
    fetchPlanos(){
      this.loading = true;
      this.$store
        .dispatch("fetchApoiadorPlanos")
        .then((value) => {
          this.planosKey += 1;
          this.planos = value;
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os planos",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save(){
      this.loading = true;
      this.$store
        .dispatch("savePlanos", this.apoiadorPlano)
        .then((value) => {
            this.$store.dispatch("setNotification", {
                type: "info",
                text: "Plano adicionado",
            });
            this.dialog = false;
            this.fetchPlanos();
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os planos",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
  }

}
</script>

<style>

</style>